import { Accordion as BaseAccordion } from "@base-ui-components/react/accordion";
import { ChevronDownIcon } from "@spoctech/icons";
import { ComponentProps } from "react";
import { accordionItemClasses } from "./AccordionItem.style";
import Typography from "@/Typography";

type AccordionItemProps = ComponentProps<typeof BaseAccordion.Item> & {
  title?: string;
  subtitle?: string;
  description?: string;
};

const {
  rootClasses,
  buttonClasses,
  titleClasses,
  accordionPanel,
  indicatorClasses,
} = accordionItemClasses();

const AccordionItem = (props: AccordionItemProps) => {
  const { title, description, subtitle, children, ...other } = props;
  return (
    <BaseAccordion.Item className={rootClasses({})} {...other}>
      <BaseAccordion.Header
        render={(props) => {
          return <div {...props} />;
        }}
      >
        <BaseAccordion.Trigger className={buttonClasses({})}>
          <Typography className={titleClasses({})}>{title}</Typography>
          {subtitle && <Typography>{subtitle}</Typography>}
          <ChevronDownIcon className={indicatorClasses({})} />
        </BaseAccordion.Trigger>
      </BaseAccordion.Header>
      <BaseAccordion.Panel className={accordionPanel({})}>
        <div className="pt-3">
          {description && (
            <Typography variant="h6" render={<span />} className="text-lg">
              {description}
            </Typography>
          )}
          {children}
        </div>
      </BaseAccordion.Panel>
    </BaseAccordion.Item>
  );
};

AccordionItem.displayName = "AccordionItem";

export default AccordionItem;
